import Spinwheel from '../Spinwheel'
import PhoneInput from 'react-phone-input-2';

function AddOrUpdateSos({ formik, loader, modalId, type }) {
  // console.log(selectedCountry)

  



  return (
    <>

      <div
        className={`modal fade `}
        id={modalId}
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      // style={{display:status ? "none" : "inline"}}
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                id="confirmModalCloseBtn"
                type="button"
                className="btn-close block-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pe-0 ps-0">
              <div className="container">
                <h2>{type}</h2>
                <form onSubmit={formik?.handleSubmit} >
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="Enter"
                      value={formik?.values?.name}
                      onChange={formik?.handleChange}
                      onBlur={formik?.handleBlur}
                    />
                    {formik?.touched?.name && formik?.errors?.name && (
                      <div className="req-error">{formik.errors.name}</div>
                    )}
                  </div>
                  <PhoneInput
                    country={"ng"}
                    enableSearch={true}
                    value={formik.values.phone || ""}
                    onChange={(value) => {
                      const phoneValue = value.startsWith("+") ? value : `+${value}`;
                      formik.setFieldValue("phone", phoneValue);
                    }}
                    onBlur={() => formik.setFieldTouched("phone", true)}
                    inputClass="form-control w-100 customlogininput"
                    containerClass="w-100 border border-1 mb-3"
                    buttonClass="border-right-0"
                  />
                  <button type="submit" disabled={loader} className="btn btn-primary">
                    {loader ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddOrUpdateSos